<template>
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer" @focus="notificationsOpen">
      <feather-icon icon="BellIcon" class="cursor-pointer mt-1 sm:mr-5 mr-2" :badge="unreadCount"></feather-icon>
        <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">

            <div class="notification-top text-center p-5 bg-primary text-white">
                <p>الإشعارات</p>
                <h3 v-if="notifications.length > 0" class="text-white">{{ notifications.length }}</h3>
            </div>

            <div v-if="notifications.length === 0" class="my-4 text-gray text-center">
              <span>لا يوجد لديك إشعارات</span>
            </div>

            <VuePerfectScrollbar ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0 mb-10" :settings="settings">
                <ul class="bordered-items">
                  <vs-dropdown-item v-for="notification in notifications" :key="notification.index" >
                    <notification-item :notification="notification"/>
                  </vs-dropdown-item>
                </ul>
            </VuePerfectScrollbar>
            <div class="checkout-footer fixed bottom-0 rounded-b-lg text-primary w-full p-4 font-semibold text-center border border-b-0 border-l-0 border-r-0 border-solid d-theme-border-grey-light">
<!--                <span>عرض كل الإشعارات</span>-->
            </div>
        </vs-dropdown-menu>
    </vs-dropdown>
</template>

<script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';

    import notificationsAPI from "@/api/notificationsAPI";
    import NotificationItem from '@/views/components/NotificationItem'

    export default {
        name: "Notifications",

        components: {
            NotificationItem,
            VuePerfectScrollbar
        },

        data() {
            return {
                settings: { // perfectscrollbar settings
                    maxScrollbarLength: 60,
                    wheelSpeed: .60,
                },

                unreadCount: 0,
                notifications: [],
            }
        },
        methods: {
            isDateSameDay(first, second) {
                first = new Date(first)
                second = new Date(second)
                return first.getFullYear() === second.getFullYear() &&
                first.getMonth() === second.getMonth() &&
                first.getDate() === second.getDate()
            },
            incrementNotificationCount(index) {
                if(index !== -1) {
                    const notify = this.notifications[index]
                    this.notifications.splice(index, 1)
                    return notify.data.count+1
                } else {
                    return 1
                }
            },
            increaseNotificationUsers(index, user){
                if(index !== -1) {
                    const notify = this.notifications[index]
                    this.notifications.splice(index, 1)
                    notify.data.users.push(user)
                    return notify.data.users
                } else {
                    return [user]
                }
            },
            parsedNotification(notification) {
                let parsedNotification = {
                    to_id: notification.to_id,
                    type: notification.to_type,
                    data: JSON.parse(notification.data.replace(/\r?\n|\r/g, '')),
                    created_at: notification.created_at,
                    is_read: notification.is_read
                }

                if(parsedNotification.type === 'student_requested_to_join') {
                    const index = this.notifications.findIndex(
                        notify => notify.type === 'student_requested_to_join' &&
                          this.isDateSameDay(notify.created_at, parsedNotification.created_at) &&
                          notify.data.course_id === parsedNotification.data.course_id
                    )

                    parsedNotification.data.count = this.incrementNotificationCount(index)
                } else if(parsedNotification.type === 'post'){
                    const index = this.notifications.findIndex(
                        notify => notify.type === 'post' &&
                          this.isDateSameDay(notify.created_at, parsedNotification.created_at) &&
                          notify.data.course_id === parsedNotification.data.course_id
                    )

                    parsedNotification.data.users = this.increaseNotificationUsers(index, parsedNotification.data.user)
                } else if(parsedNotification.type === 'comment') {
                    const body = parsedNotification.data.body.split('/')
                    parsedNotification.data.body = body[0]
                    parsedNotification.data.post_id = body[1]

                    const index = this.notifications.findIndex(
                        notify => notify.type === 'comment' &&
                          this.isDateSameDay(notify.created_at, parsedNotification.created_at) &&
                          notify.data.post_id === parsedNotification.data.post_id
                    )
                    parsedNotification.data.users = this.increaseNotificationUsers(index, parsedNotification.data.user)
                }

                return parsedNotification
            },
            loadNotifications() {
                notificationsAPI.getAll()
                    .then(({data}) => {
                        this.unreadCount = data.unreadCount
                        data.notifications.forEach(notification => {
                            try {
                                this.notifications.push(this.parsedNotification(notification))
                            } catch (Exception) {
                                return false
                            }
                        })
                    })
                    .catch(error => this.$notifyError(error))
            },
            notificationsOpen() {
                if(this.unreadCount !== 0) {
                    this.unreadCount = 0
                    notificationsAPI.markAsRead()
                }
            },
            registerListener() {
                let self = this
                const channel = window.Echo.channel('notifications.user.' + this.$store.getters['auth/user'].id);
                channel.listen('.notifications', (response) => {
                    try {
                        self.unreadCount++
                        self.notifications.unshift(this.parsedNotification(response.notification))
                    } catch (Exception) {
                        return false
                    }
                });
            }

        },
        mounted() {
            this.registerListener();
            this.loadNotifications();
        }
    }
</script>

<style lang="scss">
  .notification-dropdown {
    .vs-dropdown--item {
      position: inherit;
      width: 100%;
      margin: 0;
      font-size: inherit;
      .vs-dropdown--item-link {
        padding: 0;
      }
    }
  }
</style>
